module.exports = __webpack_public_path__ + "static/media/cryptocoins.194ac472.woff";